export interface IAutomaticAction {
    created_at: Date
    frequency: string[]
    id: string;
    is_active: boolean;
    metadata: {
        email?: string[],
        api_types?: string[],
        days_to_pull?: number,
        preset_id?: string,
        date?: { type: 'absolute', value: string } | { type: 'relative', value: number },
        date_range?: {
            from: { type: 'absolute', value: string } | { type: 'relative', value: number },
            to: { type: 'absolute', value: string } | { type: 'relative', value: number }
        },
        dual_date_ranges?: Array<{
            from: { type: 'absolute', value: string } | { type: 'relative', value: number },
            to: { type: 'absolute', value: string } | { type: 'relative', value: number }
        }>,
        title?: string,
        body?: string,
        audience?: IPlayerNotifyAudience,
        dashboard_id?: string
    },
    scheduled_at: Date
    action_types_id: string | undefined
}

export interface IAutomaticActionType {
    description: string;
    id: string;
    key: string;
    metadata: {};
    name: string;
    pre_process: number;
    needs_email: boolean;
}

export interface IIntegrations {
    key: string,
    name: string,
    type: string,
    url: string
}

export type FREQUENCY_DATA_KEY_TYPE = 'gd' | 'weekly' | 'monthly'
export const FREQUENCY_DATA: { [key in FREQUENCY_DATA_KEY_TYPE]: {
    label: string;
    shortLabel: string;
    prefix: string;
    renderType: 'switch' | 'calendar';
    options: { label: string, value: string }[];
} } = {
    'weekly': {
        label: 'on specific days every week',
        shortLabel: 'Week',
        prefix: 'weekly',
        renderType: 'switch',
        options: [
            { label: 'M', value: 'weekly:monday' },
            { label: 'T', value: 'weekly:tuesday' },
            { label: 'W', value: 'weekly:wednesday' },
            { label: 'T', value: 'weekly:thursday' },
            { label: 'F', value: 'weekly:friday' },
            { label: 'S', value: 'weekly:saturday' },
            { label: 'S', value: 'weekly:sunday' },
        ]
    },
    'monthly': {
        label: 'on specific days every month',
        shortLabel: 'Month',
        prefix: 'monthly',
        renderType: 'calendar',
        options: [...Array(31).keys()].map((e) => {
            return { label: `${e + 1}`, value: `monthly:${e + 1}` }
        })
    },
    'gd': {
        label: 'on days around games',
        shortLabel: 'Game Day',
        prefix: 'gd',
        renderType: 'switch',
        options: [
            { label: 'GD-4', value: 'gd:gd-4' },
            { label: 'GD-3', value: 'gd:gd-3' },
            { label: 'GD-2', value: 'gd:gd-2' },
            { label: 'GD-1', value: 'gd:gd-1' },
            { label: 'GD', value: 'gd:gd' },
            { label: 'GD+1', value: 'gd:gd+1' },
            { label: 'GD+2', value: 'gd:gd+2' },
            { label: 'GD+3', value: 'gd:gd+3' },
            { label: 'GD+4', value: 'gd:gd+4' },
        ]
    }
}
export const PLAYER_NOTIFY_ACTION_KEY = 'player-notify'
export const DASHBOARD_REPORT_ACTION_KEY = 'dashboard-report'
export const PLAYER_NOTIFY_TITLE_MAX_LENGTH = 100
export const PLAYER_NOTIFY_BODY_MAX_LENGTH = 500

export const PLAYER_NOTIFY_FULL_TEAM = 'full-team'

// The players who match any token get the notification. An id token is `player-<id>`, `pos-<id>` or `group-<id>`.
export type IPlayerNotifyAudience = string[]
